import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";
import { useWidth } from "@/utils/resize";
import { watchDom } from "@/watch";
import buriedsdk from "@/utils/zz-buried/index";
import Matrix from "@@/matrix";
import Performance from "@@/matrix/performance";
const PcFreestart = dynamic(import("@home3/pc/Freestart"));

import banner from "@images/features/ads/banner.png";
import sec1 from "@images/features/ads/sec1.png";
import sec2 from "@images/features/ads/sec2.png";
import sec3 from "@images/features/ads/sec3.png";

type Props = {};

let watchDoms: any = "";
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("features");
  const dom: any = useRef();
  const { width, display } = useWidth();

  const mobileUrl = process.env.mobileUrl;
  const pcUrl = process.env.portalUrl;

  const list = [
    {
      title: t("Page Ads Content1 Title"),
      title2: "",
      tip: t("Page Ads Content1 Desc"),
      btnWords: 'Explore Now',
      bg: "#fff",
      img: sec1,
      alt: t("Page Ads Content1 Title"),
      pcUrl: pcUrl + "/discovery/ads",
      mUrl: '/'
    },
    {
      title: t("Page Ads Content2 Title"),
      title2: "",
      tip: t("Page Ads Content2 Desc"),
      btnWords: 'Get Started',
      bg: "linear-gradient(135deg, #F6FEFF 0%, #FFEFEF 100%);",
      img: sec2,
      alt: t("Page Ads Content2 Title"),
      pcUrl: pcUrl + "/ads/soaringList",
      mUrl: '/'
    },
    {
      title: t("Page Ads Content3 Title"),
      title2: "",
      tip: t("Page Ads Content3 Desc"),
      btnWords: 'Start Free Trial',
      bg: "#ff",
      img: sec3,
      alt: t("Page Ads Content3 Title"),
      pcUrl: pcUrl + "/discovery/ads",
      mUrl: '/'
    },
  ];
  const handleJump = () => {
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `Start Free Trial按钮`,
      URL: process.env.publicApiDomain,
    });
  };

  useEffect(() => {
    if (process.browser) {
      if (dom.current) {
        if (watchDoms) clearInterval(watchDoms);
        watchDoms = watchDom();
      }
    }
  }, [dom]);

  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("Page Ads Title")}</title>
          <meta name="keywords" content={t("Page Ads Keywords")}></meta>
          <meta name="description" content={t("Page Ads Description")} />
          <script src="/js/jq.js" async />
          <script src="/js/kefu53.js" async />
        </Head>
        <div className={styles.down} ref={dom}>
          <div className={styles.center + " defeaultContainer"}>
            <div className={styles.banner}>
              <div className={styles.info + " animate-box"}>
                <h2 className={styles.title + " ant"}>{t("Page Ads Banner Title")}</h2>
                <p className={styles.desc + " ant"}>
                  {t("Page Ads Banner Desc")}
                </p>
                <a
                  rel="noreferrer"
                  onClick={handleJump}
                  href={
                    width > 1024
                      ? pcUrl + "/ads/soaringList"
                      : mobileUrl + "?from=chaodian_jiejuefangan"
                  }
                  target="_blank"
                  className={styles.btn + " ant"}
                >
                  {t("Start Free Trial")}
                </a>
              </div>
              <div className={styles.imgWrap + " animate-box"}>
                <Image
                  className="ant"
                  width={571}
                  height={468}
                  src={banner}
                  alt=""
                ></Image>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Matrix list={list}></Matrix>
          <Performance name="TikTok Ads"></Performance>
          <PcFreestart></PcFreestart>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
        "features",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
    },
  };
};

export default Index;
